import { Component, OnInit } from '@angular/core';
import { NavigationEnd, RouterOutlet } from '@angular/router';
import { NavComponent } from './components/nav/nav.component';
import { FooterComponent } from './components/footer/footer.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { ViewChild } from '@angular/core';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    NavComponent,
    FooterComponent,
    CommonModule,
    TranslateModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'Omex';

  onActive() {
    window.scroll(0, 0);
  }

  reciever(lang: string) {
    this.translate.use(lang);
  }

  languageCode: string = 'pl';

  constructor(public translate: TranslateService) {
    this.translate.setDefaultLang(this.languageCode);
    this.translate.use(this.languageCode);
  }
}
